import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const WORKTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.WorkType.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
];

export const WORKTYPE_CONFIG = {
  entityName: 'WorkType',
  localizationKey: 'General::Entity.WorkType',
  fields: WORKTYPE_FIELDS,
  permission: 'ControllingActivities.WorkTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Activities + MENU_NAME_SUFFIX,
};
